import { Cell, Grid, Heading, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import { Color } from 'csstype'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

interface AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSectionProps {
  row: BuscaCidadaoQueryResultModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeVulnerabilidadesAccordionSectionProps>
) {
  const { row, iconColor } = props

  const { cnsCidadao, cidadao } = row

  const bolsaFamilia = cidadao.beneficiarioBolsaFamilia

  return (
    <Grid key={cnsCidadao} gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='creditCardFilled' color={iconColor} />
          <Heading level={5}>Acompanhamento de vulnerabilidades</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Beneficiário do programa Bolsa Família</Text>
          <Text>{booleanToSimNaoTitleCase(bolsaFamilia.isBeneficiario)}</Text>
        </VFlow>
      </Cell>
      <Cell size={9}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Vigência do programa Bolsa Família</Text>
          <Text>{bolsaFamilia.vigencia ?? '-'}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
